const CONFIGURABLE_CONSTANTS = {
  sentryDns: '{{ENV_SENTRY_DNS}}',
  googleApiKey: '{{ENV_GOOGLE_API_KEY}}',
  pmOrg: 2,
  publicURL: '{{ENV_PUBLIC_URL}}',
  widgetAssets: '{{ENV_WIDGET_ASSETS}}',
};

export default CONFIGURABLE_CONSTANTS;
